import { IconButton, styled } from "@l2r-front/l2r-ui";

export const Container = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(3),
}))

export const ArrowButton = styled(IconButton)(({ theme }) => ({
    "&.MuiIconButton-root": {
        background: "rgba(0, 0, 0, 0.40)",
        boxShadow: theme.customShadow("LCS/Shadow-simple"),

        "&:hover": {
            background: "rgba(0, 0, 0, 0.65)",
        },

        "&:disabled": {
            background: "rgba(0, 0, 0, 0.25)",

            "& .MuiSvgIcon-root": {
                color: theme.palette["action/disabled"].main,
            },
        },

        "& .MuiSvgIcon-root": {
            color: theme.palette["common/white_states"].main,
        },
    },
}))